import { cn } from "@/lib/utils"

/** The site's Amazon Associates disclosure line, for any tool product surface. */
export function AffiliateDisclosure({ className }: { className?: string }) {
  return (
    <p className={cn("text-xs text-gray-500", className)}>
      As an Amazon Associate, we earn from qualifying purchases.
    </p>
  )
}
